import { render, staticRenderFns } from "./MainAutorizacion.vue?vue&type=template&id=a474a092"
import script from "./MainAutorizacion.vue?vue&type=script&lang=ts"
export * from "./MainAutorizacion.vue?vue&type=script&lang=ts"
import style0 from "./MainAutorizacion.vue?vue&type=style&index=0&id=a474a092&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports